var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 156,
    viewBox: "0 0 170 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_37852_12811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 158,
    height: 144,
    rx: 7,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 142,
    height: 74,
    rx: 3,
    fill: "#B7D9CB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 142,
    height: 14.0039,
    fill: "#E2F4F7",
    fillOpacity: 0.69
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 48,
    width: 82,
    height: 12,
    rx: 2,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 48,
    width: 28,
    height: 12,
    rx: 2,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 72,
    width: 82,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 98,
    width: 142,
    height: 6,
    rx: 3,
    fill: "#E6E6E6",
    fillOpacity: 0.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 112,
    width: 56,
    height: 6,
    rx: 3,
    fill: "#E6E6E6",
    fillOpacity: 0.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 112,
    width: 56,
    height: 6,
    rx: 3,
    fill: "#E6E6E6",
    fillOpacity: 0.7
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 126,
    width: 142,
    height: 10,
    rx: 4,
    fill: "#E6E6E6",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37852_12811",
    x: 0,
    y: 0,
    width: 170,
    height: 156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.0941176 0 0 0 0 0.117647 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37852_12811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37852_12811",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingPayment);
export default __webpack_public_path__ + "static/media/onboarding-payment.467ae38a74c20fc8c3bf0fa280aff57f.svg";
export { ForwardRef as ReactComponent };